import { Link } from '@on3/ui-lib/components/Link';
import { useSubscribe } from '@on3/ui-lib/components/Subscription/Provider';
import { useSite } from '@on3/ui-lib/index';
import { useDynamicRoute } from '@on3/ui-lib/utils/hooks/useDynamicRoute';
import clsx from 'clsx';

import styles from './JoinButton.module.scss';

interface JoinButtonProps {
  className?: string;
}

export const JoinButton = ({ className }: JoinButtonProps) => {
  const { subscribeText } = useSubscribe();
  const { currentSite } = useSite();
  const { formatHref } = useDynamicRoute();

  const isKsr = currentSite.key === 24;

  // Specific site urls handled
  let siteUrl = currentSite?.url || '';

  if (isKsr) {
    siteUrl = '/sites/kentucky-wildcats';
  }

  return (
    <Link
      className={clsx(styles.join, className)}
      href={formatHref({
        path: '/[url]/join/',
        params: { url: siteUrl },
      })}
    >
      {subscribeText || 'Join Now'}
    </Link>
  );
};
